var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Solid/Users/user-02                   "
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solid"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.84931 15.2527C4.49344 13.0767 7.08325 11.6667 10.0009 11.6667C12.9185 11.6667 15.5083 13.0767 17.1524 15.2527C17.1598 15.2625 17.1673 15.2724 17.1748 15.2823C17.3162 15.4692 17.4677 15.6697 17.5761 15.8631C17.7072 16.0971 17.8043 16.3679 17.7983 16.6972C17.7935 16.9619 17.7133 17.2097 17.6159 17.4054C17.5185 17.6011 17.3691 17.8145 17.1608 17.9779C16.8831 18.1959 16.5806 18.273 16.312 18.3053C16.0763 18.3335 15.797 18.3335 15.5161 18.3334C15.5035 18.3334 15.4908 18.3334 15.4782 18.3334H4.52355C4.51089 18.3334 4.49823 18.3334 4.48558 18.3334C4.20475 18.3335 3.92543 18.3335 3.68972 18.3053C3.42107 18.273 3.11864 18.1959 2.84087 17.9779C2.63259 17.8145 2.48323 17.6011 2.38583 17.4054C2.28844 17.2097 2.20823 16.9619 2.20339 16.6972C2.19737 16.3679 2.29454 16.0971 2.42565 15.8631C2.53398 15.6697 2.68555 15.4692 2.82692 15.2823C2.83441 15.2724 2.84188 15.2625 2.84931 15.2527Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41752 6.25008C5.41752 3.71878 7.46955 1.66675 10.0009 1.66675C12.5322 1.66675 14.5842 3.71878 14.5842 6.25008C14.5842 8.78139 12.5322 10.8334 10.0009 10.8334C7.46955 10.8334 5.41752 8.78139 5.41752 6.25008Z",
    fill: "#9A9A9A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.8c14ad9dbc4b80966878510926eb615d.svg";
export { ForwardRef as ReactComponent };